import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateOrderOfToppings = async (placeId, toppingsGroupId, positions) => {
  if (!placeId || !toppingsGroupId || !positions) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/toppings/${toppingsGroupId}/order`,
    data: { positions },
  });
};